import React from 'react';

/**
 * Varedata-oppsett som et produktark: små paneler med «etikett — verdi»-rader.
 * Tomme verdier vises alltid (også det er informasjon), men dempet så felt med data skiller seg ut.
 */
export const DataPanel: React.FC<{ title: string; children: React.ReactNode; className?: string }> = ({ title, children, className }) => (
  <section className={`bg-white rounded-lg shadow-sm overflow-hidden ${className ?? ''}`}>
    <h3 className="px-4 py-2.5 text-xs font-semibold uppercase tracking-wide text-gray-500 bg-gray-50 border-b border-gray-100">
      {title}
    </h3>
    <dl className="divide-y divide-gray-100">{children}</dl>
  </section>
);

const isEmpty = (value: React.ReactNode) => value === null || value === undefined || value === '' || value === '-';

export const DataRow: React.FC<{ label: string; value: React.ReactNode; mono?: boolean }> = ({ label, value, mono }) => (
  <div className="flex items-baseline justify-between gap-4 px-4 py-2">
    <dt className="text-sm text-gray-500 flex-shrink-0">{label}</dt>
    <dd className={`text-sm text-right break-words min-w-0 ${isEmpty(value) ? 'text-gray-400' : 'text-gray-900 font-medium'} ${mono && !isEmpty(value) ? 'font-mono' : ''}`}>
      {isEmpty(value) ? '–' : value}
    </dd>
  </div>
);

/**
 * Kode + beskrivelse: beskrivelsen er hovedverdien, koden dempet foran.
 * Funksjon (ikke komponent) så tom kode gir null og DataRow viser «–».
 */
export const codeValue = (code: string | number | null | undefined, desc?: string | null): React.ReactNode => {
  if (code === null || code === undefined || code === '') return null;
  if (!desc) return code;
  return <><span className="text-gray-400 font-normal mr-1.5">{code}</span>{desc}</>;
};

/** Ja/Nei som liten etikett, så avkrysningsfelt er lette å skanne. */
export const YesNo: React.FC<{ value: boolean | null | undefined; yes: string; no: string }> = ({ value, yes, no }) => {
  if (value === null || value === undefined) return null;
  return value
    ? <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700">{yes}</span>
    : <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600">{no}</span>;
};
